import { hideLoading, showLoading } from '@/common/components/kf-loader';
import createBatchAction from '@/common/lib/create-batch-action';

export const actionRequest = (type, actions = null) => {
  return createBatchAction(type, payload => actions ? [showLoading(), ...actions(payload)] : [showLoading()]);
};

export const actionDone = (type, actions) => {
  return createBatchAction(type, payload => actions ? [hideLoading(), ...actions(payload)] : [hideLoading()]);
};